var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSettingsHaulers = function SvgSettingsHaulers(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "settings-hauler",
    transform: "translate(70 -70)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_47",
    "data-name": "Rectangle 47",
    width: 50,
    height: 50,
    transform: "translate(-70 70)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_383",
    "data-name": "Path 383",
    d: "M-34.5,99H-35V95.622a1.5,1.5,0,0,0-.441-1.059l-3.122-3.122A1.5,1.5,0,0,0-39.622,91H-41V89.5A1.5,1.5,0,0,0-42.5,88h-10A1.5,1.5,0,0,0-54,89.5v10a1.5,1.5,0,0,0,1.5,1.5h.5a3,3,0,0,0,3,3,3,3,0,0,0,3-3h4a3,3,0,0,0,3,3,3,3,0,0,0,3-3h1.5a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0-34.5,99ZM-49,102.5a1.5,1.5,0,0,1-1.5-1.5A1.5,1.5,0,0,1-49,99.5a1.5,1.5,0,0,1,1.5,1.5A1.5,1.5,0,0,1-49,102.5Zm10,0a1.5,1.5,0,0,1-1.5-1.5A1.5,1.5,0,0,1-39,99.5a1.5,1.5,0,0,1,1.5,1.5A1.5,1.5,0,0,1-39,102.5Zm2.5-6.5H-41V92.5h1.378l3.122,3.122Z",
    fill: "#666"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSettingsHaulers, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/settings-haulers.5c8702a8.svg";
export { ForwardRef as ReactComponent };